import styles from './ConnectionInputForm.module.css';

/**
 * ConnectionInputForm component for initiating new connections (spoke mode)
 */
export default function ConnectionInputForm({
    nodeUrl,
    onUrlChange,
    onSubmit,
    disabled,
    disabledMessage,
    connectionMsg
}) {
    return (
        <div className={styles.section} data-sourcepanel="ConnectionInputForm.js">
            <h3>Request connection to a hub</h3>
            <div className={styles.connectionInputGroup}>
                <input 
                    type='text' 
                    placeholder='Enter the URL of a BDSA hub' 
                    value={nodeUrl} 
                    onChange={onUrlChange}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !disabled && nodeUrl.trim()) {
                            e.preventDefault();
                            onSubmit();
                        }
                    }}
                    disabled={disabled}
                />
                <button 
                    onClick={onSubmit}
                    disabled={disabled || !nodeUrl.trim()}
                >
                    Send request
                </button>
            </div>
            {disabled && disabledMessage && (
                <div className={styles.disabledMessage}>
                    {disabledMessage}
                </div>
            )}
            {connectionMsg && <div className={styles.connectionMessage}>{connectionMsg}</div>}
        </div>
    );
}

